<!-- 电池包 -->
<template>
  <div id="Home">
    <div class="carBg">
      <div class="batter" >
        <div class="flex flex-direction">
          <div class="batterBox">
            <div class="point">
              <div class="inner flex align-center flex-direction">
                <div class="title text-12 margin-top-13 padding-bottom-8">电池包ID：{{ batteryId }}</div>
                <div class="code text-14 padding-bottom-8">最高温度：{{ info.maximumMonomerTemperature }}</div>
                <div class="code text-14 padding-bottom-8">最低温度：{{ info.minimumMonomerTemperature }}</div>
                <div class="code text-14 padding-bottom-8">平均温度：{{ info.averageimumMonomerTemperature }}</div>
              </div>
            </div>
            <!-- <div class="resetPage">
              <div class="inner flex align-center justify-center">
                <img src="@/assets/images/site/arrow_small.png">返回
              </div>
            </div> -->
          </div>
        </div>
        
      </div>
    </div>
    <!-- 电池列表，30个，然后轮播 -->
    <BatteryBagList/>
    <div>
      
    </div>
  </div>
</template>

<script>
import BatteryBagList from "@/views/batteryBag/BatteryBagList.vue";
import { dataInterface } from '@/api/dataInterfaceApi';



  export default {
    name: 'home',
    components: {
      BatteryBagList
    },
    data() {
      return {
        currentIndex : 0,//当前选中
        info:'',
        batteryId:'',
      }
    },
    props: {
      batteryList: {
        type: Array,
        default: () => ([{},{},{},{},{},{},{},{}])
      },
    },
    mounted() {
      this.batteryId = this.$route.query.batteryId;

    },
    methods: {
      getData(data){
        this.selectbatteryPackTemperature(data);
      },
      selectbatteryPackTemperature(data={}){
        let _this = this;
        let params = {
          "enCode":"TiDB-dianchixiang-dianchibaowenduxinxi",
          "@battery_id":data.batteryId
        }
        dataInterface.dataFaceApi(params).then((res) => {
          if(!res) return;
          console.log("温度",res);
          res = res[0];
          _this.info = res
          setTimeout(() => {
            this.selectbatteryPackTemperature()
          }, 30000);
        })
        .catch((err) => {
          console.log(err);
        });
      },
      changeBattery(item,index){
        if(index!=this.currentIndex){
          this.currentIndex = index;
        }
      },
      //子组件触发 修改父组件数据
      changeParentIndex(index){
        this.currentIndex = index;
      },
      //返回电池箱
      jumpToBatteryBox(){
        //query-路由传参
        this.$emit("changeParentShow");
      }
    },
  }


</script>
<style lang="scss" scoped>
$green-text:#49FFF9;

// 电池遍历
$gutter-width: 13px;
$array: (1,2, 3, 4, 5, 6, 7, 8);

  .green-text{
    color:$green-text;
  }
  #Home {
    width: 100%;
    height: 100%;
    position: relative;
    min-width: 2708px;
    background:url('~@/assets/images/site/bg.png');
    background-size: 100% 100%;
  }
  .carBg{
    width:798px;
    height:485px;
    position: relative;
    top:25%;
    left:50%;
    transform: translateX(-50%);
    background:url('~@/assets/images/batteryBag/batterybag.png');
    background-size: 100% 100%;
    .batter{
      position:relative;
      // left: -90px;
      // padding: 0 35px;
      .batterBox{
        // width:238px;
        // height:44px;
        margin-top:100px;
        position:relative;
        .point{
            display:block;
            position:absolute;
            width:305px;
            height:192px;
            background:url('~@/assets/images/batteryBag/point.png');
            background-size: cover;
            bottom:20%;
            left:70%;
            z-index:999;
            .inner{
              width:228px;
              height:164px;
              margin-left:75px;
              .title{
                // border-bottom: 1px solid #3DBCC1;
                width: 80%;
              }
            }
          }
      }
    }
    
  }
  .point3{
    background: #00BAB8;
    border-radius: 2px;
    font-size: 18px;
    font-weight:500;
    padding:8px 13px;
    display: inline;
    img{
      width:16px;
      height:16px;
      margin-left:5px;
    }
  }
  .DS-font{
    font-family:'DS-Digital-Bold'
  }
.resetPage{
  position: absolute;
  top: -200px;
  .inner{
    max-width:164px;
    height: 52px;
    background: linear-gradient(180deg, rgba(14, 134, 139, 0.88) 0%, rgba(0, 43, 41, 0.6) 100%);
    border: 1px solid #1A7683;
    padding:0 34px;
  }
  img{
    width:16px;
    height:16px;
    margin-right:5px;
    transform:rotate(180deg);
  }
}
</style>